import type { Child, TimelineItem } from '@baby-tracker/contracts';
import type { MassDisplayUnit, VolumeDisplayUnit } from '@baby-tracker/validation';
import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { routePaths } from '../../../app/route-paths.js';
import { Card } from '../../ui/Card.js';
import { HistoryList } from './HistoryList.js';
import styles from './tracking.module.css';

export function RecentActivity({
    familyId,
    items,
    children,
    volumeUnit,
    massUnit,
    timeZone,
    date,
    canLog,
}: {
    familyId: string;
    items: TimelineItem[];
    children: Child[];
    volumeUnit: VolumeDisplayUnit;
    massUnit: MassDisplayUnit;
    timeZone: string;
    date: string;
    canLog: boolean;
}): ReactElement {
    const visible = items.slice(0, 8);
    return (
        <Card title="Recent activity" headingLevel={2}>
            {visible.length === 0 ? (
                <p className={styles.summary}>Nothing recorded on this day.</p>
            ) : (
                <HistoryList
                    familyId={familyId}
                    items={visible}
                    children={children}
                    volumeUnit={volumeUnit}
                    massUnit={massUnit}
                    timeZone={timeZone}
                    canLog={canLog}
                />
            )}
            <Link to={`${routePaths.history}?date=${date}`}>Open this day in History</Link>
        </Card>
    );
}
